import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { AdminRange } from '@b4b/shared';
import { useAdminOverview, useAdminTimeseries } from '../api/queries.js';
import RangeSwitch from '../components/admin/RangeSwitch.js';
import StatusRow from '../components/admin/StatusRow.js';
import AiKindCards from '../components/admin/AiKindCards.js';
import AiTimeseriesChart from '../components/admin/AiTimeseriesChart.js';
import QualityPanel from '../components/admin/QualityPanel.js';
import TranslationsTable from '../components/admin/TranslationsTable.js';
import UsersTable from '../components/admin/UsersTable.js';

export default function Admin() {
  const { t } = useTranslation();
  const [range, setRange] = useState<AdminRange>('30d');
  const overview = useAdminOverview(range);
  const timeseries = useAdminTimeseries(range);
  const today = timeseries.data?.days.at(-1);

  return (
    <main className="mx-auto max-w-5xl space-y-6 px-4 py-4">
      <header className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <h1 className="text-xl font-bold">{t('admin.title')}</h1>
        <RangeSwitch value={range} onChange={setRange} />
      </header>

      {overview.isPending ? <p className="text-neutral-500">{t('common.loading')}</p> : null}
      {overview.isError ? <p className="text-red-600">{t('admin.loadError')}</p> : null}

      {overview.data ? (
        <>
          <StatusRow overview={overview.data} todayCalls={today?.calls ?? 0} todayCost={today?.costUsd ?? 0} />

          <section className="space-y-3">
            <h2 className="font-semibold">{t('admin.ai.title')}</h2>
            <AiKindCards overview={overview.data} />
          </section>

          <AiTimeseriesChart range={range} />
          <QualityPanel overview={overview.data} />
          <TranslationsTable overview={overview.data} />
          <UsersTable overview={overview.data} />
        </>
      ) : null}
    </main>
  );
}
